module.exports = __webpack_public_path__ + "static/media/risenchrist.acf4589d.webp";